import { render, staticRenderFns } from "./customer-tab.vue?vue&type=template&id=ae0d9190&"
import script from "./customer-tab.vue?vue&type=script&lang=js&"
export * from "./customer-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports